import { render, staticRenderFns } from "./backOrder.vue?vue&type=template&id=db4b8a5a&scoped=true"
import script from "./backOrder.vue?vue&type=script&lang=js"
export * from "./backOrder.vue?vue&type=script&lang=js"
import style0 from "./backOrder.vue?vue&type=style&index=0&id=db4b8a5a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db4b8a5a",
  null
  
)

export default component.exports